module.exports = __webpack_public_path__ + "static/media/31JFA4.21478c48.jpg";